import PropTypes from "prop-types"
import styled from "styled-components"
import { fontRegular } from "../../utils/fontFamily"

const Container = styled.div`
  display: flex;
  align-items: ${(props) => props.alignItems};
  .large-font {
    font-size: 18px;
  }
  .mobile-app-description {
    margin-top: 40px;
  }

  ul,
  ol,
  p,
  div,
  address {
    ${fontRegular()};
  }
  .text-center {
    text-align: center;
  }
  ${({ theme }) => theme.se`
    width: 100%;
    flex-direction: column;
    .organise-description{
      font-size: 17px;
      text-align: left;
    }
  &.communicate-wrapper{
    flex-direction: column-reverse;
    padding-bottom: 0px;
    position: relative;
  }
  &.mobile-app-wrapper{
    padding: 0px 20px 10px;
  }
  &.sales-funnel-wrapper{
    padding: 80px 20px 5px;
  }
  .communicate-text-wrapper{
    text-align: center;
    width: 83%;
  }
  &.table-container{
   display: none;
    }
    &.capture-lead-container{
      min-height: 700px;
      position: relative;
      padding-bottom: 0px;
    }
  `}
  ${({ theme }) => theme.phone`
     &.capture-lead-container{
      min-height: 770px;
    }
  `}
 ${({ theme }) => theme.tablet`
    padding: 50px 20px;
    flex-direction: ${(props) => props.fxLayout};
    flex-wrap: wrap;
    justify-content: space-between;
    .organise-description{
      font-size: 16px;
    }
    &.reduced-padding-container{
  padding: 25px 20px 60px;
}
&.powerful-action-wrapper{
  padding:40px 20px 30px;
}
&.padding-top-40{
  padding-top: 40px;
}
&.pricing-header-ss{
      display: inline-flex;
    width: 100%;
    align-items: flex-start;
  justify-content: space-between;
  padding-bottom: 0px; 
}
.pricing-page-header{
      width: 48%;
}
.promo-code-ss{
  margin-top: 0px;
}
&.main-container-ss{
  padding-top: 0px;
  padding-bottom: 30px;
}
&.feature-comparison-wrapper{
  padding-top: 0px;
  padding-bottom: 0px;
}
&.simple-card-container{
  padding-top: 10px;
  padding-bottom: 0px;
}
&.
awesome-feature-container{
  padding-top: 10px;
}
    &.padding-b-0 {
      padding-bottom: 0px;
    }
    &.table-container{
      padding-left: 50px;
      padding-right: 0px;
        display: block;
    background-color: rgb(255, 255, 255);
    border: 1px solid rgb(221, 221, 221);
    border-radius: 10px;
    box-shadow: rgb(0 0 0 / 10%) 0px 4px 10px;
    overflow: hidden;
    position: relative;
    padding: 20px;
    width: 100%;
    margin: 40px auto 0px;
    }   

  &.mobile-app-wrapper{
    justify-content: center;
  }
  &.communicate-wrapper{
    padding-bottom: 50px;
  }
   .communicate-text-wrapper{ 
    text-align: left;
    width: 83%;
  }
   
.credit-child-row td{
  padding-top: 10px;
	padding-bottom: 0px;
  padding-left: 25px;
}
.credit-child-row td div{
  padding-left: 25px;
}
.credits-parent-row td{
  padding-bottom: 0px;
}
.credit-last-child td{
  padding-bottom: 10px !important; 
}
table.custom-feature-table tr td:first-child{
  padding-left: 30px;
}
table.custom-feature-table{
  width: 100%;
}
.feature-plan-header{
  padding-left: 5px;
  font-size: 20px !important;
}
.feature-pricing-header {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100px;
  font-weight: 700 !important;
  text-transform: capitalize;
  font-size: 20px !important;
}
 &.capture-lead-container{
      min-height: 980px;
    }
  `}
    ${({ theme }) => theme.desktop`
    padding: 60px 20px;
    flex-direction: row;
    flex-direction: ${(props) => props.fxLayout};
    max-width: 1200px;
    align-items: ${(props) => props.alignItems};
    // align-items: ${({ alignTop }) => (alignTop ? "flex-start" : "center")};

    .pricing-page-header{
      width: auto;
}
    .header{
      font-size: 38px;
}
&.simple-card-container{
  padding-top: 40px;
  padding-bottom: 0px;
}
&.pricing-header-ss{
  margin-bottom: 40px;
}
// &.awesome-feature-container{
//   padding-top: 0px;
// }
&.table-container{
      // padding-left: 80px;
      padding-right: auto;
      width: 97%;
    }
    &.communicate-wrapper{
    flex-direction:row;
  }
  &.mobile-app-wrapper{
    padding: 60px 20px 10px;
    justify-content: flex-start;

  }
  .communicate-text-wrapper{
    text-align: right;
    width: 100%;
  }
  .promo-code-ss{
  margin-top: 20px;
  margin-bottom:20px;
}
.credit-child-row td div{
 padding-left: 35px;
}
.feature-pricing-header {
  width: 185px;
  font-size: 24px !important;
}.feature-plan-header{
  font-size: 24px !important;
}
   &.capture-lead-container{
      min-height: 1080px;
      // position: relative;
      // padding-bottom: 0px;
    }

  `}
    ${({ theme }) => theme.largeDesktop`
    padding: 60px 20px;
    max-width: 1400px;
    flex-direction: ${(props) => props.fxLayout};

    &.padding-top-bottom-20 {
      padding-top: 20px;
      padding-bottom: 20px;
    }
    &.padding-top-20{
      padding-top: 20px;
    }
    &.padding-bottom-20{
      padding-bottom: 20px;
    }
    &.padding-top-0{
      padding-top: 0px;
    }
    .header{
      font-size: 40px;
}

.feature-plan-header{
  padding-left: 15px;
  font-size: 24px !important;
}
table.custom-feature-table tr td:first-child{
  padding-left: 50px;
}

&.table-container{
      width: 96%;
    }
    .feature-pricing-header {
  width: 200px;
}
  `};
`

Container.propTypes = {
  alignTop: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  className: PropTypes.string,
}

Container.defaultProps = {
  className: "",
  alignTop: false,
  alignItems: "",
  fxLayout: "row",
}

export default Container
